import { isMonsterZone } from './_shared';

/**
 * **ステータスの変化**（疑似イベント。Issue #584 / #589）。分岐は無い。
 * 事実: `cards` を**場の表側のモンスター**に絞り、`zone` / `code` / `defense` を盤面から付ける。残らなければ null
 */
export default Object.freeze({
  event: 'stat_change',
  label: 'ステータスの変化',
  variants: Object.freeze([]),
  classify({ payload, board }) {
    const cards = (payload?.cards ?? []).map((c) => {
      const at = c?.uid ? board?.byUid?.(c.uid) : null;
      const card = at?.card ?? null;
      if (!card || !card.faceUp || !isMonsterZone(at.zone)) return null;
      return { ...c, zone: at.zone, code: card.code ?? c.code ?? null, defense: Boolean(card.defense) };
    }).filter(Boolean);
    return cards.length ? { ...payload, cards } : null;
  },
});
